import './styles.css';
import { generatePlayerId } from '@slap/shared';
import { createRoom, uploadProof } from './api.js';
import { GameClient } from './net.js';

const TAGS = [
  (n) => `Slap your friends, ${n}.`,
  (n) => `${n}. Eyes open.`,
  (n) => `${n} vs the world.`,
  (n) => `Slap of the day, ${n}.`,
  (n) => `${n} — fastest fingers win.`,
  (n) => `Go find it, ${n}.`,
  (n) => `${n}. Hunt. Slap. Win.`,
  (n) => `No mercy, ${n}.`,
];
const STATIC = ['Eyes open. Be first.', 'The hunt is on.', 'Spot it. Slap it. Win.', 'Be first or be nothing.'];

const PACKS = [
  {
    id: 'city',
    ico: '🏙️',
    name: 'City Hunt',
    desc: '5 things on any city street',
    items: [
      { e: '🟡', n: 'Yellow vehicle' },
      { e: '🚲', n: 'Bicycle' },
      { e: '☕', n: 'Café sign' },
      { e: '🌳', n: 'Street tree' },
      { e: '📮', n: 'Postbox' },
    ],
  },
  {
    id: 'farm',
    ico: '🌾',
    name: 'Countryside',
    desc: '5 classic rural sights',
    items: [
      { e: '🐄', n: 'Cow' },
      { e: '⛪', n: 'Church tower' },
      { e: '🌻', n: 'Sunflower field' },
      { e: '🚜', n: 'Tractor' },
      { e: '🐑', n: 'Sheep' },
    ],
  },
  {
    id: 'wheels',
    ico: '🚗',
    name: 'Vehicles',
    desc: '5 rides to spot',
    items: [
      { e: '🚒', n: 'Fire truck' },
      { e: '🛵', n: 'Moped' },
      { e: '🚐', n: 'Minibus' },
      { e: '🚑', n: 'Ambulance' },
      { e: '🏍️', n: 'Motorcycle' },
    ],
  },
  {
    id: 'sacred',
    ico: '⛪',
    name: 'Sacred Spots',
    desc: '5 types of religious architecture',
    items: [
      { e: '⛪', n: 'Church spire' },
      { e: '🕌', n: 'Mosque' },
      { e: '🛕', n: 'Temple' },
      { e: '🕍', n: 'Synagogue' },
      { e: '🏛️', n: 'Chapel' },
    ],
  },
  { id: 'custom', ico: '✦', name: 'Build your own', desc: 'Pick up to 8 items yourself', items: [] },
];

const ME = { name: 'Player', id: generatePlayerId() };
let ROOM = null;
let selPack = null;
let custItems = [];
let isHost = false;
let photoData = null;
let camStream = null;
let allProofs = [];
const client = new GameClient();

// ── Welcome ──────────────────────────────────────────────
(function initWelcome() {
  let si = 0;
  const el = document.getElementById('sw-tag');
  setInterval(() => {
    el.style.opacity = '0';
    setTimeout(() => {
      el.textContent = STATIC[si++ % STATIC.length];
      el.style.opacity = '1';
    }, 280);
  }, 2800);
})();

function enterLobby() {
  const n = document.getElementById('w-name').value.trim();
  if (!n) {
    toast('Add your name first!');
    document.getElementById('w-name').focus();
    return;
  }
  ME.name = n;
  const fn = TAGS[Math.floor(Math.random() * TAGS.length)];
  document.getElementById('l-name').textContent = n;
  document.getElementById('l-line').textContent = `"${fn(n)}"`;
  go('sl');
}

// ── Packs ────────────────────────────────────────────────
function goPacks() {
  selPack = null;
  custItems = [];
  renderPacks();
  go('sp');
}

function renderPacks() {
  const list = document.getElementById('pack-list');
  list.innerHTML = PACKS.map(
    (p, i) => `
    <div class="pack${selPack && selPack.id === p.id ? ' sel' : ''}" data-pack="${i}">
      <div class="pack-ico">${p.ico}</div>
      <div class="pack-info">
        <div class="pack-name">${p.name}</div>
        <div class="pack-desc">${p.desc}</div>
      </div>
      <div class="pack-check"></div>
    </div>`
  ).join('');
  list.querySelectorAll('[data-pack]').forEach((el) => {
    el.addEventListener('click', () => selP(Number(el.dataset.pack)));
  });
  document.getElementById('cust-area').style.display = selPack && selPack.id === 'custom' ? 'block' : 'none';
  const showFoot =
    (selPack && selPack.id !== 'custom') || (selPack && selPack.id === 'custom' && custItems.length >= 2);
  document.getElementById('pack-foot').style.display = showFoot ? 'block' : 'none';
}

function selP(i) {
  selPack = PACKS[i];
  renderPacks();
}

function addCustItem() {
  const n = document.getElementById('ci-name').value.trim();
  if (!n) return;
  if (custItems.length >= 8) {
    toast('Max 8 items!');
    return;
  }
  custItems.push({ e: document.getElementById('ci-emoji').value, n });
  document.getElementById('ci-name').value = '';
  renderChips();
  renderPacks();
}

function rmChip(i) {
  custItems.splice(i, 1);
  renderChips();
  renderPacks();
}

function renderChips() {
  document.getElementById('cust-chips').innerHTML = custItems
    .map(
      (c, i) =>
        `<div class="chip" data-chip="${i}">${c.e} ${c.n} <span class="chip-rm">✕</span></div>`
    )
    .join('');
  document.getElementById('cust-chips').querySelectorAll('[data-chip]').forEach((el) => {
    el.addEventListener('click', () => rmChip(Number(el.dataset.chip)));
  });
}

// ── Room / network ───────────────────────────────────────
function applyRoomState(room) {
  ROOM = room;
  isHost = room.hostId === ME.id;
  if (room.status === 'playing' && document.getElementById('sg').classList.contains('on') === false) {
    document.getElementById('proof-strip').innerHTML = '';
    allProofs = [];
    go('sg');
  }
  if (room.status === 'lobby') {
    renderRoom();
  }
  if (document.getElementById('sg').classList.contains('on')) {
    renderScores();
    if (room.cur) updateRound();
  }
}

function setupNetworkHandlers() {
  client.onMessage((m) => {
    if (m.type === 'state' && m.room) {
      applyRoomState(m.room);
    } else if (m.type === 'player_joined') {
      toast(`${m.player.name} joined!`);
    } else if (m.type === 'game_started') {
      allProofs = [];
      document.getElementById('proof-strip').innerHTML = '';
      go('sg');
    } else if (m.type === 'round') {
      if (ROOM) {
        ROOM.round = m.round;
        ROOM.cur = m.cur;
        ROOM.total = m.total;
        ROOM.active = true;
      }
      updateRound();
    } else if (m.type === 'slap_result') {
      if (ROOM) ROOM.active = false;
      const mine = m.winnerId === ME.id;
      if (!mine) {
        vib([200, 80, 200, 80, 200]);
        shake();
      } else {
        vib([40, 25, 70]);
      }
      if (m.proofUrl) {
        allProofs.push({ player: m.winnerName, img: m.proofUrl });
        addProof(m.proofUrl, m.winnerName);
      }
      showOv(mine, m.winnerName, m.proofUrl);
      setTimeout(hideOv, 2400);
    } else if (m.type === 'finished') {
      setTimeout(() => showResult(m.players, m.proofs), 400);
    } else if (m.type === 'error') {
      toast(m.message);
    }
  });
}

async function connectToRoom(code) {
  try {
    await client.connect(code);
    client.join(ME.id, ME.name);
  } catch {
    toast('Could not connect — is the game server running?');
    throw new Error('connect failed');
  }
}

async function launchRoom() {
  if (!selPack) {
    toast('Pick a pack!');
    return;
  }
  if (selPack.id === 'custom' && custItems.length < 2) {
    toast('Add at least 2 items!');
    return;
  }
  const items = selPack.id === 'custom' ? custItems : selPack.items;
  const pack = { ...selPack, items };

  try {
    const { code } = await createRoom(ME.id, ME.name, pack);
    ROOM = {
      code,
      hostId: ME.id,
      pack,
      players: [{ id: ME.id, name: ME.name, score: 0 }],
      round: 0,
      total: items.length,
      active: false,
      cur: null,
      status: 'lobby',
    };
    allProofs = [];
    isHost = true;
    await connectToRoom(code);
    renderRoom();
    go('sr');
  } catch (err) {
    toast(err.message || 'Could not create room');
  }
}

function goJoin() {
  go('sj');
  setTimeout(() => document.getElementById('d0').focus(), 300);
}

async function joinRoom() {
  const code = [0, 1, 2, 3]
    .map((i) => document.getElementById('d' + i).value)
    .join('')
    .toUpperCase();
  if (code.length < 4) {
    toast('Enter the full 4-letter code');
    return;
  }

  toast('Joining ' + code + '…');
  allProofs = [];
  isHost = false;

  try {
    await connectToRoom(code);
    ROOM = {
      code,
      hostId: null,
      pack: PACKS[0],
      players: [{ id: ME.id, name: ME.name, score: 0 }],
      round: 0,
      total: 5,
      active: false,
      cur: null,
      status: 'lobby',
    };
    go('sr');
    renderRoom();
  } catch {
    /* toast shown in connect */
  }
}

function renderRoom() {
  if (!ROOM) return;
  document.getElementById('r-title').textContent = isHost ? 'Your room' : 'Waiting…';
  let h = '';
  if (isHost) {
    h += `<div class="code-box"><div class="cb-lbl">Room code — share with friends</div>
        <div class="cb-code">${ROOM.code}</div>
        <div class="cb-hint">Friends open the link on their phone and join with this code</div></div>`;
  } else {
    h += `<div style="text-align:center;padding:24px 0 8px;">
        <div style="font-family:'Syne',sans-serif;font-size:22px;font-weight:800;color:var(--Y);">Room ${ROOM.code}</div>
        <div style="font-size:13px;color:var(--muted);margin-top:4px;">Waiting for host to start…</div></div>`;
  }
  h += `<div><div class="lbl">Players</div><div class="pl-list" id="pl-list"></div></div>`;
  if (isHost) {
    h += `<button class="btn b-grn" id="btn-host-start">Start game →</button>
        <div class="hint-txt">Need at least 2 players. Share code <strong style="color:var(--Y);">${ROOM.code}</strong> with a friend.</div>`;
  }
  document.getElementById('r-body').innerHTML = h;
  renderPList();
  const startBtn = document.getElementById('btn-host-start');
  if (startBtn) startBtn.addEventListener('click', hostStart);
}

function renderPList() {
  const el = document.getElementById('pl-list');
  if (!el || !ROOM) return;
  el.innerHTML = ROOM.players
    .map(
      (p) => `
    <div class="pl-row">
      <span class="pl-name">${p.name}${p.id === ME.id ? ' (you)' : ''}</span>
      <span class="pl-badge${p.id === ROOM.hostId ? ' host' : ''}">${p.id === ROOM.hostId ? 'host' : 'ready'}</span>
    </div>`
    )
    .join('');
}

function hostStart() {
  if (!ROOM || !isHost) return;
  if (ROOM.players.length < 2) {
    toast('Waiting for at least one more player…');
    return;
  }
  try {
    client.start();
  } catch {
    toast('Not connected to server');
  }
}

// ── Game UI ──────────────────────────────────────────────
function updateRound() {
  if (!ROOM || !ROOM.cur) return;
  const t = ROOM.cur;
  document.getElementById('g-te').textContent = t.e;
  document.getElementById('g-tn').textContent = t.n;
  document.getElementById('g-rl').textContent = `Round ${ROOM.round} / ${ROOM.total}`;
  document.getElementById('g-hint').textContent = '👀 Stay sharp…';
  renderScores();
}

function renderScores() {
  if (!ROOM) return;
  document.getElementById('g-sc').innerHTML = ROOM.players
    .map(
      (p) => `
    <div class="sc${p.id === ME.id ? ' me' : ''}">
      <div class="sc-n">${p.name}</div>
      <div class="sc-p">${p.score}</div>
    </div>`
    )
    .join('');
}

// ── Camera / slap ────────────────────────────────────────
function onSlap() {
  if (!ROOM || !ROOM.active) return;
  openCam();
}

async function openCam() {
  const cam = document.getElementById('cam');
  document.getElementById('camv').style.display = 'block';
  document.getElementById('campr').style.display = 'none';
  document.getElementById('cb-shoot').style.display = 'flex';
  document.getElementById('cb-confirm').style.display = 'none';
  cam.classList.add('on');
  try {
    camStream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment' },
      audio: false,
    });
    document.getElementById('camv').srcObject = camStream;
  } catch {
    cam.classList.remove('on');
    toast('No camera — submitting without photo');
    submitSlap(null);
  }
}

function camShoot() {
  const v = document.getElementById('camv');
  const c = document.getElementById('camc');
  const pr = document.getElementById('campr');
  c.width = v.videoWidth || 640;
  c.height = v.videoHeight || 480;
  const cx = c.getContext('2d');
  cx.drawImage(v, 0, 0, c.width, c.height);
  const t = ROOM.cur;
  const fh = Math.floor(c.height * 0.11);
  const stamp = t.e + ' ' + t.n;
  cx.fillStyle = 'rgba(0,0,0,.45)';
  cx.fillRect(0, c.height - fh * 1.6, c.width, fh * 1.6);
  cx.fillStyle = '#E7A73C';
  cx.font = `bold ${Math.floor(fh * 0.7)}px sans-serif`;
  cx.fillText(stamp, 12, c.height - 10);
  photoData = c.toDataURL('image/jpeg', 0.72);
  pr.src = photoData;
  pr.style.display = 'block';
  v.style.display = 'none';
  document.getElementById('cb-shoot').style.display = 'none';
  document.getElementById('cb-confirm').style.display = 'flex';
}

function camRetake() {
  document.getElementById('camv').style.display = 'block';
  document.getElementById('campr').style.display = 'none';
  document.getElementById('cb-shoot').style.display = 'flex';
  document.getElementById('cb-confirm').style.display = 'none';
  photoData = null;
}

function camClose(sub) {
  stopCam();
  document.getElementById('cam').classList.remove('on');
  if (!sub) photoData = null;
}

function camConfirm() {
  camClose(true);
  submitSlap(photoData);
}

function stopCam() {
  if (camStream) {
    camStream.getTracks().forEach((t) => t.stop());
    camStream = null;
  }
}

async function submitSlap(img) {
  if (!ROOM || !ROOM.active) return;
  let proofUrl;
  try {
    if (img) {
      proofUrl = await uploadProof(ROOM.code, ME.id, img);
    }
    client.slap(proofUrl);
  } catch {
    toast('Could not submit slap');
  }
}

// ── Overlay / results ────────────────────────────────────
function showOv(mine, who, img) {
  const ov = document.getElementById('sov');
  const pi = document.getElementById('sov-proof');
  document.getElementById('sov-ico').textContent = mine ? '👊' : '😵';
  document.getElementById('sov-ttl').textContent = mine ? 'YOU WERE FIRST!' : `${who.toUpperCase()} GOT IT!`;
  document.getElementById('sov-sub').textContent = mine
    ? `${ROOM.cur.e} ${ROOM.cur.n} — +1 point`
    : `${who} spotted ${ROOM.cur.n} before you!`;
  if (img) {
    pi.src = img;
    pi.style.display = 'block';
  } else pi.style.display = 'none';
  ov.className = 'on ' + (mine ? 'win' : 'lose');
  ov.id = 'sov';
}

function hideOv() {
  const ov = document.getElementById('sov');
  ov.className = '';
  ov.id = 'sov';
}

function addProof(img, name) {
  const s = document.getElementById('proof-strip');
  const d = document.createElement('div');
  d.className = 'proof-item';
  d.innerHTML = `<img class="proof-img" src="${img}"><div class="proof-name">${name}</div>`;
  s.appendChild(d);
}

function showResult(players, proofs) {
  go('sres');
  const sorted = [...players].sort((a, b) => b.score - a.score);
  const w = sorted[0];
  const iWon = w.id === ME.id;
  document.getElementById('res-ttl').textContent = iWon ? 'YOU WIN!' : w.name.toUpperCase() + ' WINS!';
  document.getElementById('res-sub').textContent = `${w.score} slaps across ${ROOM.total} rounds`;
  const med = ['🥇', '🥈', '🥉', '4th', '5th'];
  document.getElementById('res-scores').innerHTML = sorted
    .map(
      (p, i) => `
    <div class="rs-row">
      <span class="rs-rank">${med[i] || ''}</span>
      <span class="rs-name">${p.name}${p.id === ME.id ? ' (you)' : ''}</span>
      <span class="rs-pts">${p.score}</span>
    </div>`
    )
    .join('');
  const proofList = proofs || allProofs;
  document.getElementById('res-proofs').innerHTML = proofList
    .slice(0, 6)
    .map(
      (p) =>
        `<div class="rp-wrap"><img class="rp-img" src="${p.img}"><div class="rp-lbl">${p.player}</div></div>`
    )
    .join('');
  if (iWon) vib([100, 50, 100, 50, 300]);
}

function rematch() {
  if (isHost) {
    try {
      client.rematch();
      allProofs = [];
      go('sr');
      renderRoom();
    } catch {
      toast('Not connected');
    }
  }
}

// ── Join digits ──────────────────────────────────────────
function din(i) {
  const el = document.getElementById('d' + i);
  el.value = el.value.toUpperCase().slice(-1);
  if (el.value && i < 3) document.getElementById('d' + (i + 1)).focus();
}

function dbk(e, i) {
  if (e.key === 'Backspace' && !document.getElementById('d' + i).value && i > 0) {
    document.getElementById('d' + (i - 1)).focus();
  }
}

// ── Utils ────────────────────────────────────────────────
function go(id) {
  document.querySelectorAll('.scr').forEach((s) => s.classList.remove('on'));
  document.getElementById(id).classList.add('on');
}

function vib(p) {
  try {
    navigator.vibrate && navigator.vibrate(p);
  } catch {
    /* noop */
  }
}

function shake() {
  document.body.classList.add('shk');
  setTimeout(() => document.body.classList.remove('shk'), 500);
}

let toastT;
function toast(m) {
  const t = document.getElementById('toast');
  t.textContent = m;
  t.classList.add('on');
  clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove('on'), 2600);
}

// ── Wire UI ──────────────────────────────────────────────
setupNetworkHandlers();

document.getElementById('btn-enter').addEventListener('click', enterLobby);
document.getElementById('w-name').addEventListener('keydown', (e) => {
  if (e.key === 'Enter') enterLobby();
});
document.getElementById('btn-packs').addEventListener('click', goPacks);
document.getElementById('btn-join-screen').addEventListener('click', goJoin);
document.getElementById('btn-packs-back').addEventListener('click', () => go('sl'));
document.getElementById('btn-room-back').addEventListener('click', () => {
  client.disconnect();
  go('sp');
});
document.getElementById('btn-join-back').addEventListener('click', () => go('sl'));
document.getElementById('btn-add-item').addEventListener('click', addCustItem);
document.getElementById('ci-name').addEventListener('keydown', (e) => {
  if (e.key === 'Enter') addCustItem();
});
document.getElementById('btn-launch').addEventListener('click', launchRoom);
document.getElementById('btn-join').addEventListener('click', joinRoom);
document.getElementById('btn-slap').addEventListener('click', onSlap);
document.getElementById('btn-cam-cancel').addEventListener('click', () => camClose(false));
document.getElementById('btn-cam-shoot').addEventListener('click', camShoot);
document.getElementById('btn-cam-retake').addEventListener('click', camRetake);
document.getElementById('btn-cam-confirm').addEventListener('click', camConfirm);
document.getElementById('btn-rematch').addEventListener('click', rematch);
document.getElementById('btn-home').addEventListener('click', () => {
  client.disconnect();
  ROOM = null;
  go('sl');
});

[0, 1, 2, 3].forEach((i) => {
  const el = document.getElementById('d' + i);
  el.addEventListener('input', () => din(i));
  el.addEventListener('keydown', (e) => dbk(e, i));
});
